import { useQuery } from '@tanstack/react-query';

import { whatsappTemplatesEndpoints as endpoints } from '@/api/endpoints';
import { callGet } from '@/api/fetcher';
import { WhatsappTemplates } from '@/shared/types/broadcast';

export const fetchWhatsAppTemplates = (
  deskId: string,
  integrationId: string
): Promise<WhatsappTemplates> => callGet(endpoints.list(deskId, integrationId));

type UseWhatsAppTemplatesParams = {
  deskId: string | undefined;
  integrationId: string | undefined;
  /** Extra condition on top of having both ids, e.g. the integration being WhatsApp. */
  enabled?: boolean;
};

/** The approved and pending message templates of one WhatsApp integration. */
export const useWhatsAppTemplates = ({
  deskId,
  integrationId,
  enabled = true,
}: UseWhatsAppTemplatesParams) => {
  const { data, status } = useQuery<WhatsappTemplates, Error>({
    queryKey: [endpoints.list(deskId, integrationId)],
    queryFn: () => fetchWhatsAppTemplates(deskId, integrationId),
    enabled: enabled && Boolean(deskId) && Boolean(integrationId),
  });

  return { templates: data?.templates, status };
};
